import { inject, injectable } from 'inversify';

import { HttpResponse } from '@desygner/ui-core-api-gateway';

import { TemplatePermissionResponse } from '../models/restrictions.model';
import { TYPES } from '../restrictions.types';
import { IRestrictionsService } from '../services/restrictions.service';

export interface IRestrictionsRepository {
  fetchTemplatePermissions(templateId: number): Promise<TemplatePermissionResponse[]>;
}

@injectable()
export class RestrictionsRepository implements IRestrictionsRepository {
  constructor(
    @inject(TYPES.RestrictionsService)
    private readonly service: IRestrictionsService
  ) {}

  public async fetchTemplatePermissions(templateId: number): Promise<TemplatePermissionResponse[]> {
    const response: HttpResponse = await this.service.getTemplatePermissions(templateId);

    return response.data as TemplatePermissionResponse[];
  }
}
